import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import PanelRealCases from "@/pages/PanelRealCases";

export const Route = createFileRoute("/en/panel/cases")({
  head: () => ({
    meta: [
      { title: "Real cases from shops and bars | Retail Lemon" },
      {
        name: "description",
        content:
          "Short videos of shop and hospitality owners telling their biggest challenge and how they solved it.",
      },
      { property: "og:title", content: "Real cases from shops and bars | Retail Lemon" },
      {
        property: "og:description",
        content: "Real shopkeepers explain their challenge and the fix they applied, in 30 seconds.",
      },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: () => (
    <ProtectedRoute>
      <PanelRealCases />
    </ProtectedRoute>
  ),
});
